import { render, staticRenderFns } from "./DocumentPrintPurchase.vue?vue&type=template&id=f27fe31e&scoped=true"
import script from "./DocumentPrintPurchase.vue?vue&type=script&lang=js"
export * from "./DocumentPrintPurchase.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintPurchase.vue?vue&type=style&index=0&id=f27fe31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27fe31e",
  null
  
)

export default component.exports